/* Formulario COD propio — combos, downsell, upsell, píxeles Meta/TikTok, gracias + WhatsApp (rev 2026-09-29b) */
(function () {
  'use strict';
  var dataEl = document.getElementById('codf-data');
  if (!dataEl) return;
  var D;
  try { D = JSON.parse(dataEl.textContent); } catch (e) { console.error('[codf] config inválida', e); return; }

  var S = D.settings || {};
  var P = D.product;
  var OFFERS = (D.offers && D.offers.length) ? D.offers : null;
  // La página puede mostrar solo algunos combos (prueba A/B: una arranca en 1 unidad y otra en 2): window.__codfCombos = [1,2,3].
  // Son los índices del metafield (el servidor cobra offers[i]); si no viene nada se ven todos, como siempre.
  var SHOW = OFFERS ? OFFERS.map(function (o, i) { return i; }) : [];
  if (OFFERS && Array.isArray(window.__codfCombos)) {
    var sh = window.__codfCombos.filter(function (i) { return !!OFFERS[i]; });
    if (sh.length) SHOW = sh;
  }
  // sin el combo de 1 a la vista no se muestra "ahorras" ni precio tachado (se compararía contra algo que esa página no vende)
  // (solo en páginas con window.__codfCombos: las demás quedan exactamente como estaban)
  var CON_UNO = !Array.isArray(window.__codfCombos) || SHOW.some(function (i) { return (OFFERS[i].quantity || 1) === 1; });
  var UP = (S.upsell && S.upsell.enabled && D.upsell) ? D.upsell : null;
  var DS = (S.downsell && S.downsell.enabled && (D.twin || S.downsell.require_twin === false)) ? S.downsell : null;
  // Regalo digital del producto (metafield regalo.datos): se muestra bajo los combos y se descarga en "gracias"
  var GIFT = D.gift && D.gift.titulo ? D.gift : null;
  function giftHtml() {
    if (!GIFT) return '';
    return '<div class="codf-gift">' + (GIFT.portada ? '<img src="' + esc(GIFT.portada) + '" alt="" width="54" height="77" loading="lazy">' : '<span class="codf-gift-ico" aria-hidden="true">🎁</span>') +
      '<div><b>🎁 GRATIS con tu pedido</b><span>' + esc(GIFT.titulo) + '</span>' + (GIFT.detalle ? '<small>' + esc(GIFT.detalle) + '</small>' : '') + '</div></div>';
  }
  // casilla "envío prioritario + garantía extendida" (+$5.000) — se cobra con el producto oculto "ENVÍO PRIORITARIO"
  var BUMP = (S.bump && S.bump.enabled && S.bump.variant_id) ? S.bump : null;
  var TXT = Object.assign({
    title: 'Completa tus datos para enviar tu pedido',
    subtitle: 'Pagas cuando lo recibes en tu casa',
    button: 'CONFIRMAR PEDIDO',
    trust: ['Pago contra entrega', 'Envío gratis', 'Compra segura'],
  }, S.texts || {});
  var FIELDS = Object.assign({ last_name: 'hidden', address2: 'optional' }, S.fields || {});

  var OPTS = (P.options || []).filter(function (o) { return o && o.values && o.values.length > 1; }).length ? P.options : [];
  var DELIV = S.delivery || {};
  if (DELIV.excluded) window.CODF_EXCLUDED = DELIV.excluded;
  if (DELIV.main_cities) window.CODF_MAIN_CITIES = DELIV.main_cities;
  var UNIT = Object.assign({ one: 'unidad', many: 'unidades' }, D.unit || {});
  // Prueba A/B. Cada visitante queda fijo en A o B (se guarda en su celular). ?codf_ab=a|b para probar.
  var AB = (function () {
    var q = location.search.match(/[?&]codf_ab=([ab])/); if (q) return q[1];
    var t = S.ab_test || {}; if (!t.enabled) return 'a';
    if (t.split >= 1) return 'b'; // split 1 = B para todos, también para quien ya había quedado en A
    try {
      var v = localStorage.getItem('codf_ab');
      if (v !== 'a' && v !== 'b') { v = Math.random() < (t.split || 0.5) ? 'b' : 'a'; localStorage.setItem('codf_ab', v); }
      return v;
    } catch (e) { return 'a'; }
  })();
  // Diseño del formulario: S.layout ('a' | 'b') lo fija para todos; si no está, lo decide la prueba A/B (como antes)
  var LB = S.layout ? S.layout === 'b' : AB === 'b';
  // Prueba "tel_primero": la versión B pide primero el WhatsApp y, si se va sin dejarlo, le ofrece que le escribamos
  var TEL1 = AB === 'b' && (S.ab_test || {}).feature === 'tel_primero';
  var state = {
    variant: firstAvailable(),
    offer: OFFERS ? (function () { var p = OFFERS.findIndex(function (o) { return o.preselected; }); return SHOW.indexOf(p) >= 0 ? p : SHOW[0]; })() : -1,
    downsell: false, downsellShown: false, upsell: false, sending: false, done: false,
  };

  // ------------------------------------------------------------ utilidades
  function $(s, r) { return (r || document).querySelector(s); }
  function el(html) { var t = document.createElement('template'); t.innerHTML = html.trim(); return t.content.firstChild; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function fmt(n) { return '$' + Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.'); }
  function firstAvailable() { return P.variants.find(function (v) { return v.available; }) || P.variants[0]; }
  function disc(d, base) {
    if (!d) return 0; var v = Number(d.value) || 0;
    return d.type === 'percentage' ? Math.round(base * Math.min(v, 100) / 100) : Math.min(v, base);
  }
  function offerAt(i) { return (OFFERS && OFFERS[i]) || { quantity: 1, discount: null }; }
  function calc() {
    var o = offerAt(state.offer), qty = o.quantity || 1, unit = state.variant.price / 100;
    var us = unitsList(qty);
    var sub = us.reduce(function (a, v) { return a + v.price / 100; }, 0), off = disc(o.discount, sub);
    var ds = state.downsell && DS ? disc(DS.discount, sub - off) : 0;
    var upPrice = state.upsell && UP ? upsellPrice() : 0;
    var bp = state.bump && BUMP ? Number(BUMP.price || 5000) : 0;
    var ship = Number((S.shipping || {}).price || 0);
    return { qty: qty, unit: unit, sub: sub, off: off, ds: ds, up: upPrice, bp: bp, ship: ship, total: sub - off - ds + upPrice + bp + ship };
  }
  function upsellPrice() { var base = UP.price / 100; return Math.max(0, base - disc(S.upsell.discount, base)); }

  // ------------------------------------------------------------ rastreo (UTM, clid, cookies)
  var TRACK_KEY = 'codf_track';
  (function saveTracking() {
    var q = new URLSearchParams(location.search), t = {};
    q.forEach(function (v, k) { if (/^utm_|^(ttclid|fbclid|gclid)$/.test(k)) t[k] = v; });
    if (Object.keys(t).length) { t.full_url = location.href; try { sessionStorage.setItem(TRACK_KEY, JSON.stringify(t)); } catch (e) {} }
  })();
  function tracking() {
    var t = {}; try { t = JSON.parse(sessionStorage.getItem(TRACK_KEY) || '{}'); } catch (e) {}
    var utm = {}; Object.keys(t).forEach(function (k) { if (/^utm_/.test(k)) utm[k] = t[k]; });
    var fbc = cookie('_fbc') || (t.fbclid ? 'fb.1.' + Date.now() + '.' + t.fbclid : '');
    return { utm: utm, full_url: t.full_url || location.href, ttclid: t.ttclid || '', fbp: cookie('_fbp'), fbc: fbc, ttp: cookie('_ttp') };
  }
  function cookie(n) { var m = document.cookie.match('(?:^|; )' + n + '=([^;]*)'); return m ? decodeURIComponent(m[1]) : ''; }

  // ------------------------------------------------------------ píxeles
  var PX = S.pixels || {};
  function ensurePixels() {
    var meta = PX.meta || [], tt = PX.tiktok || [];
    if (meta.length) {
      if (!window.fbq) {
        /* eslint-disable */
        !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');
        /* eslint-enable */
      }
      var have = {};
      try { var st = window.fbq.getState && window.fbq.getState(); (st && st.pixels || []).forEach(function (p) { have[p.id] = 1; }); } catch (e) {}
      window.__codfFb = window.__codfFb || {};
      meta.forEach(function (id) { if (!have[id] && !window.__codfFb[id]) { window.fbq('init', id); window.__codfFb[id] = 1; } });
    }
    if (tt.length) {
      if (!window.ttq) {
        /* eslint-disable */
        !function(w,d,t){w.TiktokAnalyticsObject=t;var ttq=w[t]=w[t]||[];ttq.methods=["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie","holdConsent","revokeConsent","grantConsent"],ttq.setAndDefer=function(t,e){t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}};for(var i=0;i<ttq.methods.length;i++)ttq.setAndDefer(ttq,ttq.methods[i]);ttq.instance=function(t){for(var e=ttq._i[t]||[],n=0;n<ttq.methods.length;n++)ttq.setAndDefer(e,ttq.methods[n]);return e},ttq.load=function(e,n){var r="https://analytics.tiktok.com/i18n/pixel/events.js";ttq._i=ttq._i||{},ttq._i[e]=[],ttq._i[e]._u=r,ttq._t=ttq._t||{},ttq._t[e]=+new Date,ttq._o=ttq._o||{},ttq._o[e]=n||{};var o=d.createElement("script");o.type="text/javascript",o.async=!0,o.src=r+"?sdkid="+e+"&lib="+t;var a=d.getElementsByTagName("script")[0];a.parentNode.insertBefore(o,a)}}(window,document,'ttq');
        /* eslint-enable */
      }
      window.ttq._i = window.ttq._i || {};
      tt.forEach(function (id) { if (!window.ttq._i[id]) window.ttq.load(id); });
    }
  }
  var VIGIA = /[?&]codf_vigia=1/.test(location.search); // robot de vigilancia: no mide, no guarda carritos, no dispara píxeles
  var NO_PX = VIGIA || /[?&]codf_nopx=1/.test(location.search); // pruebas sin ensuciar las campañas
  var pxLoaded = false, pageSent = false;
  function loadPixels() { if (pxLoaded) return; pxLoaded = true; try { ensurePixels(); } catch (e) {} }
  function track(name, data, eventId) {
    loadPixels();
    if (NO_PX) { console.log('[codf] píxel (prueba, no enviado):', name, data); return; }
    try {
      if (window.fbq && (PX.meta || []).length) window.fbq('track', name, data, eventId ? { eventID: eventId } : undefined);
    } catch (e) {}
    try {
      if (window.ttq && (PX.tiktok || []).length) {
        var ttName = name === 'Purchase' ? (PX.tiktok_purchase_event || 'Purchase') : name;
        var ttData = {
          value: data.value, currency: data.currency, content_type: 'product',
          contents: (data.content_ids || []).map(function (id) { return { content_id: String(id), quantity: data.num_items || 1 }; }),
        };
        window.ttq.track(ttName, ttData, eventId ? { event_id: eventId } : undefined);
        // eventos extra de la venta (prueba de campañas "Completar pago" / "Realizar pedido"): pixels.tiktok_extra_events
        if (name === 'Purchase') (PX.tiktok_extra_events || []).forEach(function (x) {
          if (x !== ttName) window.ttq.track(x, ttData, eventId ? { event_id: eventId } : undefined);
        });
      }
    } catch (e) {}
  }
  function identify(c) {
    if (NO_PX || !c) return;
    var ph = '57' + String(c.phone).replace(/\D/g, '').replace(/^57(?=3\d{9}$)/, '');
    var clean = function (x) { return String(x || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z]/g, ''); };
    try {
      if (window.fbq) (PX.meta || []).forEach(function (id) {
        window.fbq('init', id, { ph: ph, fn: clean(c.first_name), ln: clean(c.last_name), ct: clean(c.city), st: clean(c.province_name), country: 'co', external_id: ph });
      });
    } catch (e) {}
    try { if (window.ttq && window.ttq.identify) window.ttq.identify({ phone_number: '+' + ph, external_id: ph }); } catch (e) {}
  }
  function pixelData() {
    var c = calc();
    return { value: c.total, currency: D.currency, content_ids: [String(P.id)], content_type: 'product', num_items: c.qty };
  }

  // ------------------------------------------------------------ interfaz
  var root, sheet, form;
  function build() {
    root = el('<div class="codf" role="dialog" aria-modal="true" aria-label="Formulario de pedido" hidden>' +
      '<div class="codf-backdrop" data-close></div>' +
      '<div class="codf-sheet"><button type="button" class="codf-x" aria-label="Cerrar" data-close>&times;</button><div class="codf-body"></div></div></div>');
    if (S.style) {
      var s = S.style;
      if (s.accent) root.style.setProperty('--codf-accent', s.accent);
      if (s.accent_dark) root.style.setProperty('--codf-accent-dark', s.accent_dark);
      if (s.bg) root.style.setProperty('--codf-bg', s.bg);
    }
    document.body.appendChild(root);
    sheet = $('.codf-sheet', root);
    root.addEventListener('click', function (e) { if (e.target.closest('[data-close]')) tryClose(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !root.hidden) tryClose(); });
    renderForm();
  }

  function body() { return $('.codf-body', root); }

  function bumpHtml() {
    return '<label class="codf-bump"><input type="checkbox" name="bump_cb" aria-label="Agregar envío prioritario y garantía extendida">' +
      '<span class="codf-bump-in"><span class="codf-bump-top"><span class="codf-bump-arrow" aria-hidden="true">👉</span>' +
      '<b>' + esc(BUMP.title || '¡SÍ! Quiero ENVÍO PRIORITARIO') + '</b><em>+' + fmt(Number(BUMP.price || 5000)) + '</em></span>' +
      '<small>' + esc(BUMP.text || 'Tu pedido sale de PRIMERO 🚀 + garantía extendida 🛡️') + '</small></span></label>';
  }

  function phoneField() {
    return '<label class="codf-f' + (TEL1 ? ' codf-f-wa' : '') + '" data-f="phone"><span>' + (TEL1 ? '📱 Tu WhatsApp' : 'Celular (WhatsApp)') + '</span>' +
      (TEL1 ? '<i class="codf-f-help">Por aquí te confirmamos tu pedido</i>' : '') +
      '<div class="codf-phone"><b>+57</b><input name="phone" type="tel" inputmode="numeric" autocomplete="tel-national" placeholder="Ej: 3102938493" required></div><small class="codf-phone-st" aria-live="polite"></small><em></em></label>';
  }

  function renderForm() {
    var deptos = (window.CODF_CO || []);
    body().innerHTML =
      (LB
        ? '<div class="codf-head is-b"><h2>' + esc(TXT.title_b || 'Haz tu pedido aquí') + '</h2><p class="codf-trust-top">✓ Pagas al recibir &nbsp;·&nbsp; ✓ Envío gratis</p></div>'
        : '<div class="codf-head"><h2>' + esc(TXT.title) + '</h2><p>🚚 ' + esc(TXT.subtitle) + '</p></div>' +
          '<div class="codf-product">' +
            ((state.variant.image || P.image) ? '<img src="' + esc(state.variant.image || P.image) + '" alt="" width="64" height="64">' : '') +
            '<div><strong>' + esc(P.title) + '</strong></div>' +
          '</div>') +
      (OFFERS ? '<div class="codf-offers' + (LB ? ' is-b' : '') + '" role="radiogroup" aria-label="Elige tu oferta">' + offersHtml() + '</div>' : '') +
      giftHtml() +
      '<div class="codf-opts">' + optionsHtml() + tallaTip() + '</div>' +
      '<form class="codf-form" novalidate>' +
        (TEL1 ? phoneField() : '') +
        field('first_name', FIELDS.last_name === 'hidden' ? 'Nombre y apellido' : 'Nombre', 'text', FIELDS.last_name === 'hidden' ? 'Ej: Carlos Gómez' : 'Ej: Carlos', FIELDS.last_name === 'hidden' ? 'name' : 'given-name', true) +
        (FIELDS.last_name !== 'hidden' ? field('last_name', 'Apellido', 'text', 'Ej: Gómez', 'family-name', FIELDS.last_name === 'required') : '') +
        (TEL1 ? '' : phoneField()) +
        '<div class="codf-f" data-f="city"><span>Ciudad o municipio</span>' +
          '<div class="codf-city"><input name="city_q" type="text" autocomplete="off" autocapitalize="words" spellcheck="false" placeholder="Escribe tu ciudad, ej: Pereira" role="combobox" aria-autocomplete="list" aria-expanded="false" aria-controls="codf-sug">' +
          '<ul class="codf-sug" id="codf-sug" role="listbox" hidden></ul></div>' +
          '<input type="hidden" name="province"><input type="hidden" name="city"><em></em></div>' +
        '<div class="codf-eta" hidden></div>' +
        field('address1', 'Dirección completa', 'text', 'Ej: Calle 23 # 16-70, apto 301', 'street-address', true) +
        '<div class="codf-fix" hidden></div>' +
        '<div class="codf-hint" hidden></div>' +
        '<label class="codf-f codf-apt" data-f="apt" hidden><span>Apartamento / torre / interior</span><input name="apt" type="text" placeholder="Ej: Torre 2 apto 301" autocomplete="address-line2"><em></em></label>' +
        (FIELDS.address2 !== 'hidden' ? field('address2', 'Barrio' + (FIELDS.address2 === 'required' ? '' : ' (opcional)'), 'text', 'Ej: Barrio La Paz', 'off', FIELDS.address2 === 'required') : '') +
        (BUMP ? bumpHtml() : '') +
        '<div class="codf-total-row"></div>' +
        '<div class="codf-error" role="alert"></div>' +
        '<button type="submit" class="codf-btn"><span class="codf-btn-t"></span></button>' +
        '<ul class="codf-trust">' + TXT.trust.map(function (t) { return '<li>✓ ' + esc(t) + '</li>'; }).join('') + '</ul>' +
      '</form>';

    form = $('.codf-form', root);
    var bcb = form.querySelector('[name=bump_cb]');
    if (bcb) {
      ev('bump_show');
      bcb.addEventListener('change', function () { state.bump = bcb.checked; refreshSummary(); ev(bcb.checked ? 'bump_yes' : 'bump_no'); bcb.closest('.codf-bump').classList.toggle('is-on', bcb.checked); });
    }
    root.addEventListener('codf:city', function () { if (state.addrTouched) checkAddress(); });   // si cambia la ciudad, cambia la oficina
    setupCity();
    form.address1.addEventListener('blur', function () { setTimeout(function () { state.addrTouched = true; if (state.addrPending) applyAuto(); else checkAddress(); }, 150); });
    $('.codf-fix', root).addEventListener('click', onFixClick);
    form.phone.addEventListener('input', function () {
      // sin tope de 10 en el campo: el autocompletar/pegar trae "+57 310 123 4567" o "310 1234567" y el tope lo cortaba mal
      var d = this.value.replace(/\D/g, '');
      if (d.length > 10 && d.indexOf('57') === 0) d = d.slice(2);   // pegó +57...
      else if (d.length > 10 && d.indexOf('03') === 0) d = d.slice(1);
      this.value = d.slice(0, 10);
      phoneStatus();
    });
    form.phone.setAttribute('pattern', '3[0-9]{9}');
    if (TEL1) {
      var nudged = false;
      ['first_name', 'last_name', 'city_q', 'address1'].forEach(function (n) {
        if (!form[n]) return;
        form[n].addEventListener('focus', function () {
          if (nudged || form.phone.value.trim()) return;
          nudged = true;
          var st = $('.codf-phone-st', root);
          if (st) { st.className = 'codf-phone-st is-need'; st.textContent = '👆 Primero tu WhatsApp: por ahí te confirmamos el pedido'; }
          ev('tel_nudge', n);
        });
      });
    }
    form.addEventListener('submit', onSubmit);
    form.addEventListener('input', function (e) {
      var f = e.target.closest('.codf-f'); if (f) f.classList.remove('is-bad');
      var sn = $('.codf-soft', root); if (sn) sn.hidden = true;
      if (e.target.name !== 'hp') ev('type');
      if (e.target.name === 'phone' && !phoneProblem(e.target.value)) ev('phone');
      if (e.target.name === 'address1' && e.target.value.trim().length >= 8) ev('address');
      if (e.target.name === 'address1') { state.addrAutoDone = false; state.addrPending = null; }
      if (e.target.name === 'address1' || e.target.name === 'address2') addrSoon();
      remember(); leadSoon();
    });
    fillForm(loadRemembered());

    root.querySelectorAll('[data-offer]').forEach(function (b) {
      b.addEventListener('click', function () { state.offer = +b.getAttribute('data-offer'); refreshOffers(); renderOpts(); refreshSummary(); leadSoon(); });
    });
    $('.codf-opts', root).addEventListener('click', function (e) {
      var b = e.target.closest('[data-opt]');
      if (!b || b.disabled) return;
      pickOption(+b.getAttribute('data-u'), +b.getAttribute('data-opt'), b.getAttribute('data-val'));
    });
    refreshSummary();
  }

  // ---- ciudad con búsqueda (perdona la mala ortografía) + fecha de entrega
  // El buscador vive en codf-ciudades.js; si la página (en caché) no lo trae, lo cargamos nosotros.
  var CITIES = window.CODF_CITIES;
  var SELF_SRC = (document.currentScript && document.currentScript.src) || '';
  // carga un archivo del formulario (misma carpeta que codf-form.js) una sola vez
  var loading = {};
  function loadAsset(name, test, cb) {
    if (test()) return cb && cb();
    // cada archivo con SU versión (antes usaba la de codf-form.js y el CDN devolvía copias viejas cuando solo cambiaba uno)
    var src = (window.CODF_ASSETS && window.CODF_ASSETS[name]) || SELF_SRC.replace('codf-form.js', name);
    if (!src || src === SELF_SRC) return;
    var sc = loading[name];
    if (!sc) { sc = loading[name] = document.createElement('script'); sc.src = src; sc.async = false; document.head.appendChild(sc); }
    if (cb) sc.addEventListener('load', function () { cb(); });
  }
  function ensureCities(cb) {
    if (window.CODF_CITIES) { CITIES = window.CODF_CITIES; return cb && cb(); }
    loadAsset('codf-colombia.js', function () { return !!window.CODF_CO; }, function () {
      loadAsset('codf-ciudades.js', function () { return !!window.CODF_CITIES; }, function () { CITIES = window.CODF_CITIES; if (cb) cb(); });
    });
  }
  function setupCity() {
    var q = form.city_q, list = $('.codf-sug', root), items = [], active = -1;
    function show(res) {
      items = res; active = res.length ? 0 : -1;
      list.innerHTML = res.map(function (it, i) {
        return '<li role="option" id="codf-sug-' + i + '" data-i="' + i + '"' + (i === 0 ? ' aria-selected="true"' : '') + '><b>' + esc(it.city) + '</b><small>' + esc(it.dept) + '</small></li>';
      }).join('');
      if (res.blocked) {
        list.innerHTML = '<li class="codf-sug-none is-blocked">😔 Lo sentimos, por ahora <b>no hacemos envíos a ' + esc(res.blocked.city) + '</b>. No es posible hacer tu pedido para ese lugar.</li>';
        items = []; active = -1;
      } else if (!res.length && q.value.trim().length >= 3) {
        list.innerHTML = '<li class="codf-sug-none">No la encontramos. Revisa cómo la escribiste. <b>Si tu ciudad no aparece, por ahora no llegamos allá</b> y no es posible hacer el pedido.</li>';
      } else if (res.length) {
        list.innerHTML += '<li class="codf-sug-foot">¿No aparece tu ciudad? Por ahora no llegamos allá.</li>';
      }
      list.hidden = !list.innerHTML;
      q.setAttribute('aria-expanded', String(!list.hidden));
    }
    function mark() { list.querySelectorAll('li[data-i]').forEach(function (li) { li.setAttribute('aria-selected', String(+li.getAttribute('data-i') === active)); }); }
    q.addEventListener('input', function () {
      setCity(null, true);
      if (!CITIES) { ensureCities(function () { show(CITIES.search(q.value, 6)); }); return; }
      show(CITIES.search(q.value, 6));
    });
    q.addEventListener('keydown', function (e) {
      if (list.hidden || !items.length) return;
      if (e.key === 'ArrowDown') { active = Math.min(items.length - 1, active + 1); mark(); e.preventDefault(); }
      else if (e.key === 'ArrowUp') { active = Math.max(0, active - 1); mark(); e.preventDefault(); }
      else if (e.key === 'Enter') { e.preventDefault(); pick(items[active]); }
    });
    list.addEventListener('mousedown', function (e) { e.preventDefault(); });
    list.addEventListener('click', function (e) { var li = e.target.closest('li[data-i]'); if (li) pick(items[+li.getAttribute('data-i')]); });
    root.addEventListener('codf:city', function () { checkAddress(); });
    q.addEventListener('blur', function () {
      setTimeout(function () {
        // si escribió exacto o solo hay una opción, la tomamos sola
        var typed = q.value.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim();
        if (!state.city && items.length && (items.length === 1 || items[0].b === typed)) pick(items[0]);
        list.hidden = true; q.setAttribute('aria-expanded', 'false');
      }, 120);
    });
    function pick(it) { if (!it) return; setCity(it); list.hidden = true; q.setAttribute('aria-expanded', 'false'); var n = form.address1; if (n && !n.value) n.focus(); }
  }

  function setCity(it, keepText, silent) {
    state.city = it || null;
    form.province.value = it ? it.code : '';
    form.city.value = it ? it.city : '';
    if (it && !keepText) form.city_q.value = it.city + ', ' + it.dept;
    var box = $('.codf-eta', root);
    if (it && CITIES) {
      var e = CITIES.estimate(it, S.delivery);
      box.innerHTML = '<span aria-hidden="true">📦</span><div><b>Te llega ' + esc(e.text) + '</b><small>' + (e.main ? 'Ciudad principal' : 'Municipio') + ' · ' + e.range[0] + ' a ' + e.range[1] + ' días hábiles · pagas al recibir</small>' +
        '<i>Fecha estimada: puede variar por clima, festivos o novedades de la transportadora.</i></div>';
      box.hidden = false;
      var f = $('[data-f=city]', root); f.classList.remove('is-bad'); $('em', f).textContent = '';
      if (!silent) ev('city');
      remember(); leadSoon();
      root.dispatchEvent(new Event('codf:city'));
    } else { box.hidden = true; }
  }

  // ---- celular: exactamente 10 dígitos, empieza por 3, operador colombiano válido y no inventado
  function phoneProblem(v) {
    var d = String(v || '').replace(/\D/g, '');
    if (!d) return 'Escribe tu celular';
    if (d[0] !== '3') return 'El celular debe empezar por 3';
    if (d.length < 10) return 'Faltan ' + (10 - d.length) + ' número' + (10 - d.length === 1 ? '' : 's') + ': el celular tiene 10';
    if (d.length > 10) return 'El celular tiene solo 10 números';
    if (!/^3[0-5]/.test(d)) return 'Revisa tu celular: no parece un número de Colombia';
    if (/^3(\d)\1{8}$/.test(d) || /^3\d(\d)\1{7}$/.test(d) || d === '3123456789' || d === '3012345678' ||
        /1234567|7654321|5551234|0000000|9999999/.test(d.slice(3))) return 'Escribe tu número real para poder confirmar tu pedido';
    return '';
  }
  function phoneStatus() {
    var st = $('.codf-phone-st', root); if (!st) return;
    var v = form.phone.value, pr = phoneProblem(v);
    st.className = 'codf-phone-st' + (!v ? '' : pr ? '' : ' is-ok');
    var lab = form.phone.closest('.codf-f'); if (lab) lab.classList.toggle('is-ok', !!v && !pr);
    st.textContent = !v ? '' : pr ? (v.length < 10 && v[0] === '3' ? pr : '') : '✓ Número completo';
  }

  // ---- dirección inteligente
  //  1) si en la dirección o el barrio escribió otro municipio (ej. eligió Medellín pero escribió "Bello"), le preguntamos
  //  2) si vive en edificio/conjunto y no puso apartamento, se lo pedimos
  var addrT, dismissed = {};
  function addrSoon() { clearTimeout(addrT); addrT = setTimeout(checkAddress, 700); }
  var BUILDING = /\b(edificio|edif|ed|torre|tr|conjunto|conj|urbanizaci[oó]n|urb|unidad residencial|bloque|bl|residencias?|condominio|multifamiliar|apartamentos|reservado|parque residencial)\b/i;
  var HAS_APT = /\b(apto|apartamento|apartamentos? \d|apt|ap|int|interior|piso|casa|cs|oficina|of|local|lc|lote|lt|mz|manzana|pent ?house)\b|\b\d{3,4}\s*$/i;
  function checkAddress() {
    if (!form || !CITIES) return;
    var text = (form.address1.value || '') + ' ' + (form.address2 ? form.address2.value : '');
    var hint = $('.codf-hint', root);
    // 1) municipio escrito en la dirección
    var found = text.trim().length >= 6 ? CITIES.inText(text, state.city ? state.city.code : null, state.city) : null;
    if (found && !dismissed[found.city + found.code]) {
      hint.innerHTML = '<span aria-hidden="true">📍</span><div><b>' + (state.city
          ? 'En tu dirección escribiste «' + esc(found.city) + '». ¿Tu pedido va para ' + esc(found.city) + ' y no para ' + esc(state.city.city) + '?'
          : '¿Tu pedido es para ' + esc(found.city) + ', ' + esc(found.dept) + '?') + '</b>' +
        '<div class="codf-hint-btns"><button type="button" data-y>Sí, es ' + esc(found.city) + '</button>' +
        (state.city ? '<button type="button" data-n>No, es ' + esc(state.city.city) + '</button>' : '<button type="button" data-n>No</button>') + '</div></div>';
      hint.hidden = false;
      $('[data-y]', hint).onclick = function () { dismissed[found.city + found.code] = 1; setCity(found); hint.hidden = true; ev('city_fixed', found.city); };
      $('[data-n]', hint).onclick = function () { dismissed[found.city + found.code] = 1; hint.hidden = true; };
    } else if (!found) { hint.hidden = true; }
    // 1b) ¿la dirección está completa según su tipo? (se puede apagar con ajustes address_check=false)
    if (S.address_check === false) { renderFix(null); state.addrPending = null; }
    else if (ADDR) {
      var a1 = form.address1.value.trim();
      // vacía, muy corta ("C", "Cll": todavía no dice nada; si confirma así, sale el aviso normal) o ya completada en la cajita
      var ares = (!a1 || a1.length < 5 || a1 === state.addrOk) ? null : ADDR.analyze(a1, form.address2 ? form.address2.value : '');
      if (ares && ares.type === 'oficina' && S.pickup !== false) renderOffice();   // quiere reclamar en oficina
      else { if (a1 !== state.addrOk) state.pickup = false; renderFix(ares); }
    }
    else ensureAddr(checkAddress);

    // 2) edificio o conjunto sin apartamento
    var aptF = $('.codf-apt', root);
    var needApt = BUILDING.test(text) && !HAS_APT.test(form.address1.value) && !HAS_APT.test(form.address2 ? form.address2.value : '');
    if (needApt && aptF.hidden) {
      aptF.hidden = false;
      $('span', aptF).textContent = 'Vives en edificio o conjunto: ¿cuál es tu apartamento?';
    } else if (!needApt && !form.apt.value) { aptF.hidden = true; }
  }

  // ---- dirección completa según su tipo: le pedimos justo lo que falta (y no dejamos pasar "Barrio El Diamante" solo)
  var ADDR = window.CODF_ADDR;
  function ensureAddr(cb) {
    loadAsset('codf-direccion.js', function () { return !!window.CODF_ADDR; }, function () { ADDR = window.CODF_ADDR; if (cb) cb(); });
  }
  var VIA_NAMES = { cl: 'Calle', cll: 'Calle', clle: 'Calle', calle: 'Calle', cra: 'Carrera', carrera: 'Carrera', kr: 'Carrera', kra: 'Carrera', krr: 'Carrera', cr: 'Carrera', crr: 'Carrera', carrea: 'Carrera', carera: 'Carrera',
    karrera: 'Carrera', karera: 'Carrera', ka: 'Carrera', k: 'Carrera', av: 'Avenida', avenida: 'Avenida', tv: 'Transversal', tr: 'Transversal', trans: 'Transversal', transv: 'Transversal', transversal: 'Transversal', dg: 'Diagonal', diag: 'Diagonal', diagonal: 'Diagonal', ak: 'Avenida Carrera', ac: 'Avenida Calle', cq: 'Circular', circ: 'Circular', circular: 'Circular', autopista: 'Autopista' };
  var VIA_OPTS = ['Calle', 'Carrera', 'Avenida', 'Diagonal', 'Transversal'];
  var CHOICES = [['c_calle', '🏙️', 'Calle o carrera'], ['c_manzana', '🏘️', 'Manzana y casa'], ['c_edificio', '🏢', 'Edificio o conjunto'], ['c_finca', '🌳', 'Vereda o finca'], ['c_sinnum', '🏠', 'Mi casa no tiene número']];
  function viaName(v) { return VIA_NAMES[String(v || '').replace(/\./g, '').split(' ').pop()] || cap(String(v || 'Calle')); }
  function inp(p, ph, label, cls, val, mode) {
    return '<input data-p="' + p + '"' + (cls ? ' class="' + cls + '"' : '') + ' inputmode="' + (mode || 'text') + '" value="' + esc(val || '') + '" placeholder="' + esc(ph) + '" aria-label="' + esc(label) + '">';
  }
  function viaRow(via, n1, n2, n3, pick) {
    return '<div class="codf-fix-row">' +
      (pick ? '<select data-p="via" aria-label="Calle o carrera">' + VIA_OPTS.map(function (o) { return '<option' + (o === via ? ' selected' : '') + '>' + o + '</option>'; }).join('') + '</select>' + '</div><div class="codf-fix-row">'
            : '<span>' + esc(via) + '</span>') +
      inp('1', '23', 'Número de la ' + via, '', n1) + '<span>#</span>' + inp('2', '14', 'Número después del #', '', n2) +
      '<span>-</span>' + inp('3', '35', 'Número de la casa', '', n3) + '</div>';
  }
  var BACK = '<button type="button" class="codf-fix-alt" data-mode="elegir">‹ Cambiar</button>';
  var NO_NUM = '<button type="button" class="codf-fix-alt" data-mode="c_sinnum">Mi casa no tiene número</button>';

  function fixMode(res) {
    if (state.addrMode) return state.addrMode;                    // lo que eligió el cliente
    if (res.type === 'urbana') return 'urbana';
    if (res.type === 'manzana') return 'manzana';
    if (res.type === 'rural') return 'rural';
    if (res.type === 'referencia') return 'casa';
    return 'elegir';                                               // no parece dirección: que elija cómo es
  }
  function fixHtml(mode, res) {
    var n = (res && res.parts && res.parts.nums) || [];
    switch (mode) {
      case 'urbana':
        var via = viaName(res.parts.via), merged = n[1] && n[1].length >= 3;
        var n1 = n[0] || '', n2 = res.missing[0] === 'placa' && !merged ? (n[1] || '') : '', n3 = res.parts.dash ? (n[1] || '') : '';
        state.addrVia = via;
        return '<b>📍 Completa tu dirección para que el mensajero llegue sin problema</b>' + viaRow(via, n1, n2, n3) +
          '<small>Ejemplo: ' + esc(via) + ' 23 # 14 - 35</small>' + NO_NUM;
      case 'c_calle':
        return '<b>📍 Escribe tu dirección</b>' + viaRow('Calle', '', '', '', true) + '<small>Ejemplo: Calle 23 # 14 - 35</small>' + BACK;
      case 'manzana':
        return '<b>📍 ¿Cuál es el número de la casa o lote?</b><div class="codf-fix-row"><span>Casa / lote</span>' + inp('casa', '12', 'Casa o lote') + '</div>';
      case 'c_manzana':
        return '<b>📍 ¿Qué manzana y qué casa?</b><div class="codf-fix-row"><span>Manzana</span>' + inp('mz', 'B', 'Manzana') +
          '<span>Casa / lote</span>' + inp('casa', '12', 'Casa o lote') + '</div>' + BACK;
      case 'c_edificio':
        return '<b>📍 ¿Cómo se llama y cuál es tu apartamento?</b><div class="codf-fix-row">' + inp('ed', 'Nombre del edificio o conjunto', 'Nombre del edificio o conjunto', 'is-wide') + '</div>' +
          '<div class="codf-fix-row"><span>Torre / apto</span>' + inp('apto', 'T2 apto 301', 'Torre y apartamento', 'is-mid') + '</div>' + BACK;
      case 'rural': case 'c_finca':
        return '<b>📍 ¿Cómo se llama la finca o casa? Agrega también una referencia</b><div class="codf-fix-row">' +
          inp('finca', 'Ej: Finca El Roble, frente a la escuela', 'Finca o referencia', 'is-wide') + '</div><small>Así el mensajero llega directo a tu casa.</small>' + (mode === 'c_finca' ? BACK : '');
      case 'casa':
        return '<b>📍 ¿Cuál es el número de tu casa?</b><div class="codf-fix-row">' + inp('ref', 'Ej: casa 12', 'Número de la casa', 'is-wide') +
          '</div><small>Si no tiene número, escribe cómo es: color, rejas, qué hay al lado.</small>';
      case 'c_sinnum':
        return '<b>📍 ¿Cómo es tu casa y qué hay cerca?</b><div class="codf-fix-row">' + inp('ref', 'Ej: casa azul, al lado de la tienda', 'Cómo es tu casa', 'is-wide') +
          '</div><small>Así el mensajero la encuentra sin llamarte.</small>' + BACK;
      default: // elegir
        return '<b>📍 Tu dirección está incompleta. ¿Cómo es tu dirección?</b><div class="codf-fix-choices">' +
          CHOICES.map(function (c) { return '<button type="button" data-mode="' + c[0] + '"><i aria-hidden="true">' + c[1] + '</i>' + esc(c[2]) + '</button>'; }).join('') + '</div>';
    }
  }

  function renderFix(res) {
    var box = $('.codf-fix', root);
    state.addrFix = null;
    // números pegados: los separamos nosotros y le mostramos cómo quedó
    if (res && res.fixed && !state.addrAutoDone) {
      var fv = viaName(res.parts.via);
      var tailOrig = res.fixed.tail ? form.address1.value.replace(/^\s*\D*?\d+\s*[a-zA-Z]?\s*(bis)?[^\d]*\d+/i, '').trim() : ''; // respeta mayúsculas y tildes del cliente
      var fixedTxt = (ADDR.format && ADDR.format(form.address1.value)) ||   // conserva letras: "Carrera4a 2021" -> Carrera 4A # 20 - 21
        (fv + ' ' + res.fixed.n1 + ' # ' + res.fixed.n2 + ' - ' + res.fixed.n3 + (tailOrig ? ' ' + tailOrig : ''));
      state.addrPending = fixedTxt;
      box.innerHTML = '<b>✅ Organizamos tu dirección así: <u>' + esc(fixedTxt) + '</u></b><small>Si algo no está bien, corrígelo arriba.</small>';
      box.setAttribute('data-sig', 'auto'); box.classList.add('is-ok'); box.hidden = false;
      return;
    }
    box.classList.remove('is-ok');
    if (!res || res.complete) { box.hidden = true; box.innerHTML = ''; box.removeAttribute('data-sig'); state.addrMode = null; return; }
    // mientras escribe no lo interrumpimos: la cajita sale cuando sale del campo (o al confirmar)
    // (antes salía con "C" o "Cll" mientras seguía escribiendo: ahora solo al salir del campo o al confirmar)
    if (box.hidden && (!state.addrTouched || (document.activeElement === form.address1 && !state.addrForce))) return;
    var mode = fixMode(res);
    state.addrFix = { type: mode, via: state.addrVia || 'Calle' };
    var sig = mode + '|' + res.missing.join() + '|' + ((res.parts && res.parts.nums) || []).join();
    if (box.getAttribute('data-sig') !== sig) {
      if (box.hidden || box.getAttribute('data-sig') === 'auto') ev('addr_ask', mode + ' | ' + form.address1.value.slice(0, 50));
      box.innerHTML = fixHtml(mode, res); box.setAttribute('data-sig', sig); box.classList.remove('is-bad');
      box.querySelectorAll('input').forEach(function (i) { i.addEventListener('input', function () { box.classList.remove('is-bad'); }); });
    }
    box.hidden = false;
  }
  // ---- RECLAMAR EN OFICINA: solo Interrapidísimo y solo en municipios (no ciudades principales ni secundarias).
  // Le mostramos la dirección de la oficina de su municipio (codf-oficinas.js, descargado de la página de Interrapidísimo).
  var OFI = window.CODF_OFICINAS;
  function ensureOfi(cb) { loadAsset('codf-oficinas.js', function () { return !!window.CODF_OFICINAS; }, function () { OFI = window.CODF_OFICINAS; if (cb) cb(); }); }
  function nrm(s) { return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9ñ ]+/g, ' ').replace(/\s+/g, ' ').trim(); }
  function bigCity(c) {
    if (!c) return false;
    if (c.main) return true;
    return ((S.pickup || {}).no_cities || []).some(function (x) { var p = String(x).split('|'); return nrm(p[0]) === nrm(c.city) && (!p[1] || p[1] === c.code); });
  }
  function findOffice(c) {
    if (!OFI || !c) return null;
    var k = c.code + '|', raw = String(c.city || '');
    // "Puracé (Coconuco)" -> probamos "purace coconuco", "purace" y "coconuco"
    var names = [nrm(raw), nrm(raw.replace(/\(.*?\)/g, ''))].concat((raw.match(/\(([^)]+)\)/) || [])[1] ? [nrm(raw.match(/\(([^)]+)\)/)[1])] : []);
    for (var i = 0; i < names.length; i++) if (names[i] && OFI[k + names[i]]) return OFI[k + names[i]];
    // "Santa Fé de Antioquia" -> sin la palabra del departamento ("santa fe"), que es como lo tiene Interrapidísimo ("santafe")
    var dep = ((window.CODF_CO || []).filter(function (d) { return d.c === c.code; })[0] || {}).n || '';
    var depT = nrm(dep).split(' ');
    var toks = function (s) { return s.replace(/\b(el|la|los|las|de|del|municipio)\b/g, ' ').split(' ').filter(function (t) { return t && depT.indexOf(t) < 0; }).sort(); };
    var flat = function (s) { return s.replace(/\b(el|la|los|las|de|del|municipio)\b/g, ' ').split(' ').filter(function (t) { return t && depT.indexOf(t) < 0; }).join(''); };   // "vista hermosa" = "vistahermosa"
    var mine = names.map(toks), best = null;
    for (var key in OFI) {
      if (key.indexOf(k) !== 0) continue;
      var m = toks(key.slice(k.length));
      for (var j = 0; j < mine.length; j++) {
        var a = mine[j], sa = flat(names[j]), sm = flat(key.slice(k.length));
        if (!a.length) continue;
        if (a.join(' ') === m.join(' ') || sa === sm) return OFI[key];      // mismas palabras en otro orden / "santafe" = "santa fe"
        // uno contiene al otro: "carmen viboral" ⊂ "el carmen de viboral", "san martin" ⊂ "san martin de los llanos"
        var small = a.length <= m.length ? a : m, big = a.length <= m.length ? m : a;
        if (!best && small.join('').length >= 4 && small.every(function (t) { return big.indexOf(t) >= 0; })) best = OFI[key];
      }
    }
    return best;
  }
  function renderOffice() {
    var box = $('.codf-fix', root), c = state.city;
    // la lista de oficinas se empieza a cargar apenas escribe "oficina" (no al confirmar); si ya tocó Confirmar, se envía solo cuando cargue
    if (!OFI) {
      if (state.addrForce) {
        state.ofiSubmit = true; state.addrFix = { type: 'ofi_wait' };
        setTimeout(function () { if (state.addrFix && state.addrFix.type === 'ofi_wait') { state.addrFix = null; state.ofiSubmit = false; } }, 6000);   // si no carga, no se traba
      }
      ensureOfi(function () {
        checkAddress();
        if (state.ofiSubmit) { state.ofiSubmit = false; if (form.requestSubmit) form.requestSubmit(); else form.dispatchEvent(new Event('submit', { cancelable: true })); }
      });
      return;
    }
    if (box.hidden && (!state.addrTouched || (document.activeElement === form.address1 && !state.addrForce))) return;
    if (!c) { box.hidden = true; state.addrFix = null; return; }          // primero que elija su ciudad
    var txt = nrm(form.address1.value + ' ' + (form.address2 ? form.address2.value : ''));
    var otra = /servientrega|serv?b?i ?entrega|\benvias?\b|coordinadora|\btcc\b|\b472\b|deprisa|saferbo/.test(txt) && !/inter/.test(txt);
    var sig, html, o = null;
    box.classList.remove('is-ok', 'is-bad');
    state.pickup = false;
    if (bigCity(c)) {
      sig = 'ofi_ciudad|' + c.city;
      html = '<b>🏙️ En ' + esc(c.city) + ' no se puede reclamar en oficina</b><small>Te lo llevamos hasta tu casa: escribe arriba la dirección de tu casa (calle, carrera y número).</small>';
      state.addrFix = { type: 'ofi_no', msg: 'En ' + c.city + ' te lo llevamos a tu casa: escribe la dirección de tu casa' };
    } else if (!(o = findOffice(c))) {
      sig = 'ofi_nohay|' + c.city;
      html = '<b>📍 En ' + esc(c.city) + ' no hay oficina de Interrapidísimo para reclamar</b><small>Escribe arriba la dirección de tu casa y te lo llevamos.</small>';
      state.addrFix = { type: 'ofi_no', msg: 'En ' + c.city + ' no hay oficina para reclamar: escribe la dirección de tu casa' };
    } else {
      sig = 'ofi_ok|' + c.city + '|' + (otra ? 1 : 0);
      var okBar = /[a-z]{3}/i.test(o[1] || '');   // algunas oficinas traen el barrio como '-'
      var bar = okBar ? cap(o[1].toLowerCase()) : '';
      var map = o[3] ? 'https://www.google.com/maps/search/?api=1&query=' + o[3] + ',' + o[4] : '';
      html = '<b>📦 Lo reclamas en la oficina de Interrapidísimo de ' + esc(c.city) + '</b>' +
        '<div class="codf-ofi"><strong>' + esc(o[0]) + '</strong>' + (bar ? '<span>Barrio ' + esc(bar) + '</span>' : '') +
        (o[2] ? '<span>Tel. ' + esc(o[2]) + '</span>' : '') + (map ? '<a href="' + map + '" target="_blank" rel="noopener">📍 Ver en el mapa</a>' : '') + '</div>' +
        '<small>' + (otra ? '⚠️ Solo enviamos a oficinas de <b>Interrapidísimo</b> (no Servientrega, Envía ni otras). ' : '') + 'Lleva tu cédula para reclamarlo.</small>';
      box.classList.add('is-ok');
      state.addrFix = { type: 'ofi_ok', out: 'RECLAMA EN OFICINA INTERRAPIDISIMO ' + c.city.toUpperCase() + ': ' + o[0] + (okBar ? ' (barrio ' + o[1] + ')' : '') };
    }
    if (box.getAttribute('data-sig') !== sig) { box.innerHTML = html; box.setAttribute('data-sig', sig); ev('addr_ask', sig.split('|')[0] + ' | ' + c.city); }
    box.hidden = false;
  }

  // botones de la cajita: elegir cómo es la dirección / "mi casa no tiene número" / cambiar
  function onFixClick(e) {
    var b = e.target.closest('[data-mode]'); if (!b) return;
    var m = b.getAttribute('data-mode');
    state.addrMode = m === 'elegir' ? 'elegir' : m;
    var box = $('.codf-fix', root); box.removeAttribute('data-sig');
    checkAddress();
    var first = box.querySelector('input, select'); if (first && m !== 'elegir') first.focus();
  }

  // arma la dirección final con lo que completó en la cajita
  function applyAuto() {
    if (!state.addrPending) return;
    state.addrRaw = form.address1.value;   // como la escribió el cliente (va aparte en el pedido)
    form.address1.value = state.addrPending; state.addrPending = null; state.addrAutoDone = true;
    ev('addr_fixed', 'auto'); remember();
  }
  function composeFix(apply) {
    if (S.address_check === false) return { ok: true };
    if (apply) applyAuto();
    var f = state.addrFix, box = $('.codf-fix', root);
    if (f && f.type === 'ofi_wait') return { ok: false, msg: 'Un momento: buscando la oficina de tu municipio…' };
    if (!f || box.hidden) return { ok: true };
    var v = function (k) { var i = box.querySelector('[data-p="' + k + '"]'); return i ? i.value.trim() : ''; };
    var base = form.address1.value.trim(), out = null, t = f.type;
    if (t === 'ofi_no') return { ok: false, msg: f.msg };
    if (t === 'ofi_ok') {
      if (apply) {
        form.address1.value = f.out; state.addrOk = f.out; state.pickup = true;
        if (form.address2 && !form.address2.value.trim()) form.address2.value = 'Reclama en oficina';
        box.hidden = true; box.removeAttribute('data-sig'); state.addrFix = null; ev('addr_fixed', 'oficina'); remember();
      }
      return { ok: true };
    }
    if (t === 'urbana' || t === 'c_calle') {
      var via = t === 'c_calle' ? v('via') : f.via;
      if (!v('1') || !v('2') || !v('3')) return { ok: false, msg: 'Completa tu dirección: ' + via + ' __ # __ - __' };
      var extra = /\d/.test(base) ? base.replace(/^.*?\d[\d\s#a-zA-Z.\-]*?(?=\b(apto|apartamento|apt|torre|casa|barrio|conjunto|edificio|local|bloque|piso|int|interior|mz|manzana|lote)\b|$)/i, '').trim()
                                  : base.replace(/^\s*(calle|carrera|cra|avenida|diagonal|transversal)\b\.?/i, '').trim();
      if (t === 'c_calle') extra = base;
      out = via + ' ' + v('1') + ' # ' + v('2') + ' - ' + v('3') + (extra ? ', ' + extra : '');
    } else if (t === 'manzana') {
      if (!v('casa')) return { ok: false, msg: 'Escribe el número de la casa o lote' };
      out = base + ', Casa ' + v('casa');
    } else if (t === 'c_manzana') {
      if (!v('mz') || !v('casa')) return { ok: false, msg: 'Escribe la manzana y la casa' };
      out = 'Manzana ' + v('mz') + ' Casa ' + v('casa') + ', ' + base;
    } else if (t === 'c_edificio') {
      if (v('ed').length < 3 || !v('apto')) return { ok: false, msg: 'Escribe el nombre del edificio y tu apartamento' };
      out = v('ed') + ', ' + v('apto') + ', ' + base;
    } else if (t === 'rural' || t === 'c_finca') {
      if (v('finca').length < 4) return { ok: false, msg: 'Escribe el nombre de la finca o casa y una referencia' };
      out = base + ', ' + v('finca');
    } else if (t === 'casa') {
      var r = v('ref');
      if (!r || (!/\d/.test(r) && r.length < 6)) return { ok: false, msg: 'Escribe el número de tu casa (o cómo es si no tiene número)' };
      out = base + ', ' + (/^\d+\s*[a-z]?$/i.test(r) ? 'Casa ' + r : r);
    } else if (t === 'c_sinnum') {
      if (v('ref').length < 8) return { ok: false, msg: 'Escribe cómo es tu casa y qué hay cerca' };
      out = base + ', ' + v('ref');
    } else if (t === 'elegir') {
      return { ok: false, msg: 'Toca cómo es tu dirección y complétala' };
    }
    if (apply && out) {
      form.address1.value = out; state.addrOk = out; state.addrMode = null;
      box.hidden = true; box.removeAttribute('data-sig'); state.addrFix = null; ev('addr_fixed', t); remember();
    }
    return { ok: true };
  }

  // ---- recordar datos en este celular (si vuelve, el formulario ya está lleno)
  var MEM_KEY = 'codf_datos';
  function loadRemembered() { try { return JSON.parse(localStorage.getItem(MEM_KEY) || 'null'); } catch (e) { return null; } }
  var memT;
  function remember() {
    clearTimeout(memT);
    memT = setTimeout(function () { try { localStorage.setItem(MEM_KEY, JSON.stringify(readForm())); } catch (e) {} }, 400);
  }
  function fillForm(c) {
    if (!c || !form) return;
    ['first_name', 'last_name', 'address1', 'address2'].forEach(function (k) { if (form[k] && c[k] && !form[k].value) form[k].value = c[k]; });
    if (c.phone && !form.phone.value) form.phone.value = String(c.phone).replace(/^57(?=3\d{9}$)/, '');
    if (c.city) ensureCities(function () { var it = CITIES.find(c.city, c.province); if (it) setCity(it, false, true); });
  }

  // ---- carrito abandonado: apenas deja nombre + celular, queda guardado (como hacía EasySell) para que Lucidbot lo contacte
  var leadT, lastLead = '';
  state.lead = (function () { try { return sessionStorage.getItem('codf_lead_' + P.id) || null; } catch (e) { return null; } })();
  function leadSoon(now) { clearTimeout(leadT); leadT = setTimeout(sendLead, now ? 0 : 2500); }
  function sendLead(keepalive) {
    if (state.done || !D.endpoint || !form || VIGIA || /[?&]codf_dry=1/.test(location.search)) return;
    var c = readForm();
    if ((!c.first_name && !TEL1) || phoneProblem(c.phone)) return;
    var body = JSON.stringify({ product_id: P.id, variant_id: state.variant.id, units: unitIds(), offer_index: OFFERS ? state.offer : -1, customer: c,
      tracking: tracking(), page_url: location.href, lead: state.lead, sec: secInfo(), rescue: state.rescued ? 1 : undefined, ab: AB, ver: window.__codfVer || undefined });
    var sig = body.replace(/"tracking":\{.*?\},/, '');
    if (sig === lastLead) return;
    lastLead = sig;
    fetch(D.endpoint.replace(/\/$/, '') + '/lead', { method: 'POST', headers: { 'Content-Type': 'text/plain;charset=UTF-8' }, body: body, keepalive: !!keepalive })
      .then(function (r) { return r.json(); })
      .then(function (r) { if (r && r.lead) { state.lead = r.lead; try { sessionStorage.setItem('codf_lead_' + P.id, r.lead); } catch (e) {} } })
      .catch(function () { lastLead = ''; });
  }

  // ---- medición paso a paso (panel)
  var SID = (function () { try { var x = sessionStorage.getItem('codf_s'); if (!x || x.charAt(1) !== '-' || x.charAt(0) !== AB.toUpperCase()) { x = AB.toUpperCase() + '-' + Math.random().toString(36).slice(2) + Date.now().toString(36); sessionStorage.setItem('codf_s', x); } return x; } catch (e) { return AB.toUpperCase() + '-' + Math.random().toString(36).slice(2); } })();
  var sentSteps = {}, evQ = [], evT;
  // prueba del botón fijo (la pone el tema en <html data-stk="ya|baja">): se anota en view/open para medir
  function STK() { return document.documentElement.getAttribute('data-stk') || ''; }
  function ev(k, info) {
    if (VIGIA) return;
    if (k !== 'error') { if (sentSteps[k]) return; sentSteps[k] = 1; }
    evQ.push({ k: k, i: info || '' });
    clearTimeout(evT); evT = setTimeout(flushEv, 600);
  }
  function flushEv() {
    if (!evQ.length || !D.endpoint) return;
    var data = JSON.stringify({ s: SID, p: String(P.id), t: P.title, m: /Mobi|Android/i.test(navigator.userAgent) ? 1 : 0, e: evQ.splice(0) });
    var url = D.endpoint.replace(/\/$/, '') + '/e';
    try { if (navigator.sendBeacon && navigator.sendBeacon(url, new Blob([data], { type: 'text/plain' }))) return; } catch (e) {}
    fetch(url, { method: 'POST', body: data, keepalive: true, headers: { 'Content-Type': 'text/plain' } }).catch(function () {});
  }
  window.addEventListener('pagehide', function () { flushEv(); sendLead(true); });
  window.addEventListener('error', function (e) {
    if (e && e.filename && /codf-/.test(e.filename)) ev('error', 'js:' + String(e.message).slice(0, 120) + ' @' + (e.lineno || ''));
  });
  document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'hidden') { flushEv(); sendLead(true); } });

  function field(name, label, type, ph, ac, req) {
    return '<label class="codf-f" data-f="' + name + '"><span>' + esc(label) + '</span><input name="' + name + '" type="' + type + '" placeholder="' + esc(ph) + '" autocomplete="' + ac + '"' + (req ? ' required' : '') + '><em></em></label>';
  }

  // ---- selector de variantes: una fila por opción; colores = muestras redondas, tallas = botones
  var COLORS = {
    'dorado': 'linear-gradient(135deg,#fbe7a1 0%,#d4a936 45%,#f6dc86 70%,#b8891f 100%)',
    'oro': 'linear-gradient(135deg,#fbe7a1 0%,#d4a936 45%,#f6dc86 70%,#b8891f 100%)',
    'oro rosa': 'linear-gradient(135deg,#f9dccf 0%,#d99a86 45%,#f3c7b5 70%,#b97764 100%)',
    'rose gold': 'linear-gradient(135deg,#f9dccf 0%,#d99a86 45%,#f3c7b5 70%,#b97764 100%)',
    'plateado': 'linear-gradient(135deg,#ffffff 0%,#b9bdc3 45%,#eceef0 70%,#8e9399 100%)',
    'plata': 'linear-gradient(135deg,#ffffff 0%,#b9bdc3 45%,#eceef0 70%,#8e9399 100%)',
    'cobre': 'linear-gradient(135deg,#f3b58a 0%,#b8672f 50%,#e59a62 100%)',
    'negro': '#1d1d1f', 'blanco': '#ffffff', 'gris': '#9ca3af', 'gris oscuro': '#4b5563', 'rojo': '#dc2626', 'vino': '#7f1d1d',
    'azul': '#2563eb', 'azul oscuro': '#1e3a8a', 'azul marino': '#1e2a5a', 'celeste': '#7dd3fc', 'verde': '#16a34a', 'verde oliva': '#6b7a3a',
    'amarillo': '#facc15', 'naranja': '#f97316', 'rosado': '#f9a8d4', 'rosa': '#f9a8d4', 'fucsia': '#db2777', 'morado': '#7c3aed', 'lila': '#c4b5fd',
    'beige': '#e8d5b7', 'nude': '#e6c3a5', 'piel': '#e6c3a5', 'cafe': '#7c4a2d', 'marron': '#7c4a2d', 'crema': '#f5ecd7',
    'cocoa': '#5c3d2e', 'verde militar': '#4b5320', 'azul rey': '#1d4ed8', 'gris jaspeado': 'repeating-linear-gradient(45deg,#9ca3af 0 2px,#c3c7cf 2px 4px)',
    'transparente': 'repeating-conic-gradient(#e5e7eb 0% 25%,#fff 0% 50%) 50%/10px 10px'
  };
  function colorOf(val) { var k = String(val).toLowerCase().trim(); return COLORS[k] || COLORS[k.normalize('NFD').replace(/[\u0300-\u036f]/g, '')] || null; }
  function isColorOpt(o) { return /colou?r|tono/i.test(o.name) || o.values.every(colorOf); }

  function unitsList(n) {
    state.units = state.units || [state.variant];
    while (state.units.length < n) state.units.push(state.units[state.units.length - 1]);
    return state.units.slice(0, n);
  }
  function unitsCount() { return OFFERS ? (offerAt(state.offer).quantity || 1) : 1; }
  function cap(t) { return t.charAt(0).toUpperCase() + t.slice(1); }

  function optAvailable(u, i, val) {
    var sel = (state.units[u] || state.variant).options || [];
    return P.variants.some(function (v) {
      if (!v.available || !v.options || v.options[i] !== val) return false;
      for (var j = 0; j < i; j++) if (v.options[j] !== sel[j]) return false;
      return true;
    });
  }

  function variantImageFor(i, val) {
    var v = P.variants.find(function (x) { return x.options && x.options[i] === val && x.image && x.image !== P.image; });
    return v ? v.image : '';
  }

  function optionsHtml() {
    if (!OPTS.length) return '';
    var n = unitsCount(), units = unitsList(n);
    var colorish = OPTS.some(isColorOpt);
    var head = n > 1 ? '<div class="codf-units-h">Elige ' + (colorish ? 'el color' : 'la opción') + ' de cada ' + esc(UNIT.one) + ' <span>' + n + ' ' + esc(UNIT.many) + '</span></div>' : '';
    return head + units.map(function (uv, u) {
      var sel = uv.options || [];
      return '<div class="codf-unit' + (n > 1 ? ' is-multi' : '') + '" style="--i:' + u + '">' +
        (n > 1 ? '<div class="codf-unit-n"><b>' + (u + 1) + '</b></div>' : '') +
        '<div class="codf-unit-body">' +
        OPTS.map(function (o, i) {
          if (!o.values || o.values.length < 2) return '';
          var color = isColorOpt(o);
          return '<div class="codf-opt"><div class="codf-opt-h">' + (n > 1 ? esc(cap(UNIT.one)) + ' ' + (u + 1) + ' · ' : '') + esc(o.name) + ': <b>' + esc(sel[i] || '') + '</b></div>' +
            '<div class="' + (color ? 'codf-swatches' : 'codf-chips') + (n > 1 ? ' is-compact' : '') + '" role="radiogroup" aria-label="' + esc(o.name) + ' ' + (u + 1) + '">' +
            o.values.map(function (val) {
              var on = sel[i] === val, ok = optAvailable(u, i, val), bg = color && colorOf(val);
              var img = color && !bg ? variantImageFor(i, val) : '';
              var inner = color
                ? '<span class="codf-sw-dot"' + (bg ? ' style="background:' + bg + '"' : '') + '>' + (img ? '<img src="' + esc(img) + '" alt="">' : (!bg ? esc(String(val).slice(0, 2)) : '')) + '</span><span class="codf-sw-n">' + esc(val) + '</span>'
                : esc(val);
              return '<button type="button" role="radio" aria-checked="' + on + '" data-u="' + u + '" data-opt="' + i + '" data-val="' + esc(val) + '" class="' +
                (color ? 'codf-sw' : 'codf-chip') + (on ? ' is-on' : '') + (ok ? '' : ' is-out') + '"' + (ok ? '' : ' disabled') + '>' + inner + '</button>';
            }).join('') + '</div></div>';
        }).join('') + '</div></div>';
    }).join('');
  }

  // la página puede dejar una frase de "¿qué talla pido?" (window.__codfTallaNota) que sale debajo de las tallas
  function tallaTip() {
    var t = window.__codfTallaNota;
    if (!t || !OPTS.some(function (o) { return /talla|size/i.test(o.name) && o.values && o.values.length > 1; })) return '';
    return '<p class="codf-size-tip"><span aria-hidden="true">📏</span><span>' + esc(t) + '</span></p>';
  }

  function renderOpts(popU, popI) {
    var box = $('.codf-opts', root); if (!box) return;
    box.innerHTML = optionsHtml() + tallaTip();
    if (popU != null) { var on = box.querySelector('[data-u="' + popU + '"][data-opt="' + popI + '"].is-on'); if (on) on.classList.add('is-pop'); }
  }

  function pickOption(u, i, val) {
    var cur = state.units[u] || state.variant;
    var want = (cur.options || []).slice(); want[i] = val;
    var v = P.variants.find(function (x) { return x.available && x.options.every(function (o, j) { return o === want[j]; }); }) ||
            P.variants.find(function (x) { return x.available && x.options[i] === val; });
    if (!v) return;
    state.units[u] = v;
    if (u === 0) state.variant = v;
    renderOpts(u, i);
    var im = $('.codf-product img', root); if (im && (v.image || P.image)) im.src = v.image || P.image;
    refreshOffers(); refreshSummary(); remember(); leadSoon();
  }

  // Etiqueta de cada oferta: la 2 = "el más pedido", la última = "máximo ahorro -X%".
  // (EasySell traía "Los más populares" repetido en la 2 y la 3: esa etiqueta se reemplaza sola)
  function offerRibbon(o, i, sub, off) {
    var custom = o.label && !/m[aá]s populares?/i.test(o.label) ? o.label : '';
    if (custom) return { text: custom, kind: 'hot' };
    var k = SHOW.indexOf(i), n = SHOW.length;
    if (!OFFERS || n < 2 || k <= 0) return null;
    var pctOff = sub && CON_UNO ? Math.round((off / sub) * 100) : 0;
    if (k === n - 1 && n >= 3) return { text: '💰 MÁXIMO AHORRO' + (pctOff ? ' −' + pctOff + '%' : ''), kind: 'save' };
    return { text: '🔥 EL MÁS PEDIDO', kind: 'hot' };
  }

  function offersHtml() {
    var cards = SHOW.map(function (i) { return offerCard(OFFERS[i], i); }).join('');
    if (!LB) return cards;
    var o = offerAt(state.offer), sub = (state.variant.price / 100) * (o.quantity || 1), off = disc(o.discount, sub);
    return '<div class="codf-segs" style="grid-template-columns:repeat(' + SHOW.length + ',minmax(0,1fr))">' + cards + '</div>' +
      '<div class="codf-seg-save">' + (off > 0 && CON_UNO ? 'Ahorras <b>' + fmt(off) + '</b> · sale a ' + fmt((sub - off) / o.quantity) + ' cada uno'
        : (!CON_UNO && o.quantity > 1 ? 'Sale a <b>' + fmt((sub - off) / o.quantity) + '</b> cada uno' : '&nbsp;')) + '</div>';
  }

  function offerCard(o, i) {
    var unit = state.variant.price / 100, sub = unit * o.quantity, off = disc(o.discount, sub), on = i === state.offer;
    var rb = offerRibbon(o, i, sub, off);
    if (LB) {
      // botón simple: número + palabra del producto (ej. "2 arrancadores", "1 set · 13 piezas") + precio
      var lbl = o.quantity + ' ' + (o.quantity === 1 ? UNIT.one : UNIT.many);
      var det = UNIT.per ? (o.quantity * UNIT.per) + ' ' + (UNIT.per_word || 'piezas') : '';
      // etiqueta corta por posición (las etiquetas largas de EasySell no caben en el botón): 2ª = más pedido, última = más ahorro
      var k = SHOW.indexOf(i), n = SHOW.length, tag = n < 2 || k <= 0 ? '' : (k === n - 1 && n >= 3 ? '💰 Más ahorro' : '🔥 Más pedido');
      rb = tag ? { kind: tag.indexOf('ahorro') > 0 ? 'save' : 'hot' } : null;
      return '<button type="button" role="radio" aria-checked="' + on + '" class="codf-seg' + (on ? ' is-on' : '') + (rb ? ' is-' + rb.kind : '') + '" data-offer="' + i + '">' +
        (tag ? '<i class="codf-seg-tag">' + tag + '</i>' : '') +
        '<b>' + esc(lbl) + '</b>' + (det ? '<small>' + esc(det) + '</small>' : '') +
        '<strong>' + fmt(sub - off) + '</strong></button>';
    }
    return '<button type="button" role="radio" aria-checked="' + on + '" class="codf-offer' + (on ? ' is-on' : '') + (rb ? ' has-ribbon is-' + rb.kind : '') + '" data-offer="' + i + '">' +
      (rb ? '<span class="codf-ribbon is-' + rb.kind + '">' + esc(rb.text) + '</span>' : '') +
      '<span class="codf-radio" aria-hidden="true"></span>' +
      '<span class="codf-offer-main"><strong>' + esc(o.title || ('Lleva ' + o.quantity)) + '</strong>' +
        '<span class="codf-qty">📦 ' + o.quantity + ' ' + esc(o.quantity === 1 ? UNIT.one : UNIT.many) + '</span>' +
        (o.badge ? '<span class="codf-badge">' + esc(o.badge) + '</span>' : '') +
        (off > 0 && CON_UNO ? '<small>Ahorras ' + fmt(off) + '</small>' : '') + '</span>' +
      '<span class="codf-offer-price"><b>' + fmt(sub - off) + '</b>' + (off > 0 && CON_UNO ? '<s>' + fmt(sub) + '</s>' : '') +
        (o.quantity > 1 ? '<em>Sale a ' + fmt((sub - off) / o.quantity) + ' c/u</em>' : '') + '</span>' +
    '</button>';
  }

  function refreshOffers() {
    if (!OFFERS) return;
    var box = $('.codf-offers', root);
    box.innerHTML = offersHtml();
    box.querySelectorAll('[data-offer]').forEach(function (b) {
      b.addEventListener('click', function () { state.offer = +b.getAttribute('data-offer'); refreshOffers(); renderOpts(); refreshSummary(); leadSoon(); });
    });
  }

  function refreshSummary() {
    var c = calc(), before = c.sub + c.up + c.bp + c.ship;
    $('.codf-total-row', root).innerHTML = '<span>Total a pagar al recibir</span><span>' +
      (before > c.total && CON_UNO ? '<s>' + fmt(before) + '</s> ' : '') + '<b>' + fmt(c.total) + '</b></span>';
    $('.codf-btn-t', root).textContent = TXT.button + ' · ' + fmt(c.total);
  }

  // ------------------------------------------------------------ abrir / cerrar / downsell
  var icSent = false, lastFocus = null;
  // señales para la guardia anti-fraude del servidor: cuánto tardó en llenar el formulario y si el navegador es un robot
  function secInfo() { return { ms: state.openedAt ? Date.now() - state.openedAt : 0, wd: !!(navigator && navigator.webdriver) }; }

  function open() {
    if (!state.openedAt) state.openedAt = Date.now();
    if (!root) build();
    ensureCities(); ensureAddr();
    if (!state.hist) { try { history.pushState({ codf: 1 }, ''); state.hist = true; } catch (e) {} }
    lastFocus = document.activeElement;
    root.hidden = false;
    document.documentElement.classList.add('codf-lock');
    var sb = document.querySelector('.codf-sticky'); if (sb) sb.hidden = true;
    requestAnimationFrame(function () { root.classList.add('is-open'); });
    setTimeout(function () { var i = form && form.querySelector('input[name=first_name]'); if (i && window.innerWidth > 768) i.focus(); }, 250);
    if (!icSent) { icSent = true; track('InitiateCheckout', pixelData()); }
    ev('open', (state.openSrc || 'boton') + (STK() ? '|' + STK() : ''));   // desde dónde abrió: boton / fijo / hero (se ve en revisar.py)
    state.openSrc = null;
  }
  function close(fromBack) {
    if (state.hist && fromBack !== true) { state.hist = false; state.skipPop = true; try { history.back(); } catch (e) {} }
    if (!state.done) { ev('close'); leadSoon(true); }
    var sb = document.querySelector('.codf-sticky'), ctaEl = document.querySelector('.codf-cta');
    if (sb && ctaEl) { var rr = ctaEl.getBoundingClientRect(); sb.hidden = rr.top < innerHeight && rr.bottom > 0; }
    root.classList.remove('is-open');
    document.documentElement.classList.remove('codf-lock');
    setTimeout(function () { root.hidden = true; }, 200);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  window.addEventListener('popstate', function () {
    if (state.skipPop) { state.skipPop = false; return; }
    if (!root || root.hidden) return;
    state.hist = false;
    var repush = function () { try { history.pushState({ codf: 1 }, ''); state.hist = true; } catch (e) {} };
    if (state.sending) { repush(); return; }
    if (!state.done && DS && !state.downsellShown && !state.downsell) { state.downsellShown = true; repush(); ev('back_downsell'); showDownsell(); return; }
    var ov = sheet && sheet.querySelector('.codf-over'); if (ov && ov.done) ov.done();
    if (canRescue()) { repush(); showRescue(); return; }
    close(true);
  });
  function tryClose() {
    if (state.sending) return;
    if (state.done) { close(); return; }
    if (DS && !state.downsellShown && !state.downsell) { state.downsellShown = true; showDownsell(); return; }
    if (canRescue()) { showRescue(); return; }
    close();
  }

  // ---- RESCATE AL SALIR (versión B): "¿Prefieres que te escribamos por WhatsApp?" — solo si todavía no dejó su número
  function canRescue() { return TEL1 && !state.done && !state.rescueShown && !!form && !!phoneProblem(form.phone.value); }
  function showRescue() {
    state.rescueShown = true;
    ev('rescue_show');
    var ov = overlay('<div class="codf-over codf-rescue">' +
      '<div class="codf-ds-gift" aria-hidden="true">💬</div>' +
      '<h3>¿Prefieres que te escribamos por WhatsApp?</h3>' +
      '<p>Déjanos tu número y te ayudamos a hacer tu pedido. Pagas al recibir.</p>' +
      '<input class="codf-rescue-in" name="r_name" type="text" placeholder="Tu nombre" autocomplete="given-name">' +
      '<div class="codf-phone codf-rescue-ph"><b>+57</b><input name="r_phone" type="tel" inputmode="numeric" placeholder="Tu WhatsApp: 3102938493" autocomplete="tel-national"></div>' +
      '<em class="codf-rescue-err" aria-live="polite"></em>' +
      '<button type="button" class="codf-btn" data-yes>SÍ, ESCRÍBANME 💬</button>' +
      '<button type="button" class="codf-link" data-no>No, gracias</button></div>');
    var ph = $('[name=r_phone]', ov), nm = $('[name=r_name]', ov), er = $('.codf-rescue-err', ov);
    if (form.first_name.value.trim()) nm.value = form.first_name.value.trim();
    ph.addEventListener('input', function () { var d = this.value.replace(/\D/g, ''); if (d.length > 10 && d.indexOf('57') === 0) d = d.slice(2); this.value = d.slice(0, 10); er.textContent = ''; });
    $('[data-yes]', ov).addEventListener('click', function () {
      var pr = phoneProblem(ph.value);
      if (pr) { er.textContent = pr; ph.focus(); return; }
      form.phone.value = ph.value; if (nm.value.trim() && !form.first_name.value.trim()) form.first_name.value = nm.value.trim();
      phoneStatus(); remember();
      state.rescued = true; ev('rescue_yes'); sendLead(true);
      ov.innerHTML = '<div class="codf-ds-gift" aria-hidden="true">✅</div><h3>¡Listo! Te escribimos por WhatsApp</h3><p>En unos minutos te llega un mensaje para terminar tu pedido.</p>';
      setTimeout(function () { ov.done(); close(); }, 2200);
    });
    $('[data-no]', ov).addEventListener('click', function () { ev('rescue_no'); ov.done(); close(); });
  }

  function overlay(html) {
    sheet.scrollTop = 0; sheet.classList.add('has-over');
    var ov = el(html); sheet.appendChild(ov);
    ov.done = function () { ov.remove(); sheet.classList.remove('has-over'); };
    return ov;
  }

  function showDownsell() {
    var c = calc(), save = disc(DS.discount, c.sub - c.off);
    ev('downsell_show');
    var ov = overlay('<div class="codf-over codf-ds">' +
      '<div class="codf-ds-gift" aria-hidden="true">🎁</div>' +
      '<h3>' + esc(DS.title || '¡Espera! No te vayas') + '</h3>' +
      '<p>' + esc((DS.text || 'Te regalamos {descuento} de descuento si terminas tu pedido ahora.').replace('{descuento}', fmt(save))) + '</p>' +
      '<div class="codf-ds-price"><s>' + fmt(c.total) + '</s> <b>' + fmt(c.total - save) + '</b></div>' +
      '<button type="button" class="codf-btn" data-yes>' + esc(DS.accept || 'SÍ, QUIERO MI DESCUENTO') + '</button>' +
      '<button type="button" class="codf-link" data-no>' + esc(DS.reject || 'No gracias, pagaré el precio completo') + '</button></div>');
    $('[data-yes]', ov).addEventListener('click', function () {
      state.downsell = true; ov.done(); refreshSummary(); ev('downsell_yes');
      var s = $('.codf-total-row', root); if (s) s.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
    $('[data-no]', ov).addEventListener('click', function () { ev('downsell_no'); ov.done(); if (canRescue()) showRescue(); else close(); });
  }

  // ------------------------------------------------------------ enviar / upsell
  function readForm() {
    var f = form, full = f.first_name.value.trim().replace(/\s+/g, ' ');
    var first = full, last = f.last_name ? f.last_name.value.trim() : '';
    if (!f.last_name && full.indexOf(' ') > 0) { first = full.slice(0, full.indexOf(' ')); last = full.slice(full.indexOf(' ') + 1); }
    return {
      first_name: first, last_name: last,
      phone: f.phone.value.replace(/\D/g, ''),
      province: f.province.value, province_name: state.city ? state.city.dept : '',
      city: f.city.value, address1: (f.address1.value.trim() + (f.apt && f.apt.value.trim() && !$('.codf-apt', root).hidden ? ', ' + f.apt.value.trim() : '')),
      address2: f.address2 ? f.address2.value.trim() : '',
    };
  }
  function validate(c) {
    var e = {};
    if (!c.first_name) e.first_name = 'Escribe tu nombre';
    var phErr = phoneProblem(c.phone);
    if (phErr) e.phone = phErr;
    if (!c.province || !c.city) e.city = form.city_q.value.trim() ? 'Toca tu ciudad en la lista que aparece' : 'Escribe tu ciudad o municipio';
    if (c.address1.length < 5) e.address1 = 'Escribe tu dirección completa';

    var fx = composeFix(false);
    if (!fx.ok) e.address1 = fx.msg;
    var aptBox = $('.codf-apt', root);
    if (aptBox && !aptBox.hidden && !form.apt.value.trim()) e.apt = 'Escribe tu apartamento, torre o interior (si es casa, escribe "casa")';
    if (FIELDS.last_name === 'required' && !c.last_name) e.last_name = 'Escribe tu apellido';
    if (FIELDS.address2 === 'required' && !c.address2) e.address2 = 'Escribe tu barrio';
    return e;
  }
  function showErrors(errs) {
    var fixBox = root && $('.codf-fix', root);
    if (fixBox && !fixBox.hidden && errs.address1) { fixBox.classList.add('is-bad'); }
    root.querySelectorAll('.codf-f').forEach(function (f) {
      var k = f.getAttribute('data-f'), m = errs[k];
      f.classList.toggle('is-bad', !!m); $('em', f).textContent = m || '';
    });
    var first = root.querySelector('.codf-f.is-bad input:not([type=hidden]), .codf-f.is-bad select');
    if (first) { first.focus(); first.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
  }

  function onSubmit(e) {
    e.preventDefault();
    if (state.sending) return;
    // formulario vacío (1 de cada 6 toca "Confirmar" sin escribir nada): sin pintar todo de rojo,
    // lo llevamos amablemente al primer campo
    if (!form.first_name.value.trim() && !form.phone.value.trim() && !form.city_q.value.trim() && !form.address1.value.trim()) {
      var note = $('.codf-soft', root);
      if (!note) { note = document.createElement('p'); note.className = 'codf-soft'; form.insertBefore(note, form.firstChild); }
      note.textContent = '👇 Escribe tus datos y te enviamos tu pedido. Pagas al recibir.'; note.hidden = false;
      (TEL1 ? form.phone : form.first_name).focus(); note.scrollIntoView({ behavior: 'smooth', block: 'start' });
      ev('error', 'validacion:vacio');
      return;
    }
    // barrio vacío pero lo escribió en la dirección ("Calle 5 # 3-20 barrio La Paz"): lo tomamos de ahí
    if (form.address2 && !form.address2.value.trim()) {
      var bm = form.address1.value.match(/(?:^|[\s,])(?:barrio|bario|brr|br\.|b\/)\s*:?\s*([A-Za-zÁÉÍÓÚÑáéíóúñ][^,#\d]{2,40})/i);
      if (bm) { form.address2.value = bm[1].trim(); ev('addr_fixed', 'barrio_de_la_direccion'); }
    }
    state.addrTouched = true; state.addrForce = true; checkAddress(); state.addrForce = false;   // revisa la dirección aunque no haya salido del campo
    composeFix(true); // si completó la cajita de dirección, la pegamos antes de validar
    // si escribió la ciudad pero no la tocó en la lista, tomamos la más parecida (menos fricción)
    if (!state.city && CITIES && form.city_q.value.trim().length >= 3) {
      var best = CITIES.search(form.city_q.value, 2);
      // solo si el parecido es casi exacto (nombre igual, empieza igual o suena igual) y no hay dos ciudades
      // casi iguales (ej. dos "Armenia"); si hay duda, que elija de la lista
      var clear = best.scores && best.scores[0] >= 78 && (best.scores.length < 2 || best.scores[0] - best.scores[1] >= 6);
      if (best[0] && !best.blocked && clear) { setCity(best[0]); ev('city_autopick', form.city_q.value.slice(0, 40) + ' -> ' + best[0].city); }
    }
    var c = readForm(), errs = validate(c);
    showErrors(errs);
    if (Object.keys(errs).length) {
      // si falla la ciudad, anotamos qué escribió (para mejorar el buscador)
      var cityTxt = errs.city ? '|ciudad:"' + form.city_q.value.trim().slice(0, 40) + '"' + (CITIES ? '' : ' (buscador sin cargar)') : '';
      var pd = form.phone.value.replace(/\D/g, '');   // qué tiene mal el celular (sin guardar el número)
      if (errs.phone) cityTxt += '|cel:' + pd.length + 'dig,empieza' + (pd[0] || '-');
      ev('error', 'validacion:' + Object.keys(errs).join(',') + cityTxt);
      return;
    }
    ev('submit');
    if (state.pickup) c.pickup = 1;   // reclama en oficina de Interrapidísimo (el servidor lo marca en el pedido)
    // la dirección llega ORDENADA a Shopify, Dropi y Lucid: "Kra 12 23 36" -> "Carrera 12 # 23 - 36"
    if (ADDR && ADDR.format && S.address_format !== false) {
      try { var fm = ADDR.format(c.address1); if (fm && fm !== c.address1) { c.address_original = c.address1; c.address1 = fm; } } catch (er) {}
    }
    if (!c.address_original && state.addrAutoDone && state.addrRaw) c.address_original = state.addrRaw;
    if (S.address_check === false && ADDR) {
      var ar = ADDR.analyze(c.address1, c.address2);
      if (ar.fixed || !ar.complete) ev('addr_incomplete', ar.type + ':' + (ar.fixed ? 'numeros_pegados' : ar.missing.join('+')) + ' | ' + c.address1.slice(0, 60));
    }
    if (UP && !state.upsellShown) { state.upsellShown = true; showUpsell(function () { send(c); }); return; }
    send(c);
  }

  function showUpsell(next) {
    var price = upsellPrice(), base = UP.price / 100;
    ev('upsell_show');
    var ov = overlay('<div class="codf-over codf-up">' +
      '<p class="codf-up-kicker">' + esc(S.upsell.kicker || '¡OFERTA ÚNICA! Solo por hoy') + '</p>' +
      '<h3>' + esc(S.upsell.title || ('Agrega ' + UP.title + ' a tu pedido')) + '</h3>' +
      (UP.image ? '<img src="' + esc(UP.image) + '" alt="" width="220" height="220">' : '') +
      '<div class="codf-ds-price">' + (price < base ? '<s>' + fmt(base) + '</s> ' : '') + '<b>' + fmt(price) + '</b></div>' +
      (S.upsell.text ? '<p>' + esc(S.upsell.text) + '</p>' : '') +
      '<button type="button" class="codf-btn" data-yes>' + esc(S.upsell.accept || 'SÍ, AGREGAR A MI PEDIDO') + '</button>' +
      '<button type="button" class="codf-link" data-no>' + esc(S.upsell.reject || 'No gracias, finalizar mi pedido') + '</button></div>');
    $('[data-yes]', ov).addEventListener('click', function () { state.upsell = true; ev('upsell_yes'); ov.done(); refreshSummary(); next(); });
    $('[data-no]', ov).addEventListener('click', function () { ov.done(); next(); });
  }

  function showDuplicate(c, prev) {
    ev('duplicate');
    var ov = overlay('<div class="codf-over codf-dup">' +
      '<div class="codf-check" aria-hidden="true">✓</div>' +
      '<h3>¡' + esc(c.first_name) + ', tu pedido ya está registrado!</h3>' +
      '<p>Ya tienes el pedido <b>' + esc(prev.order_name) + '</b>' + (prev.product_title ? ' de <b>' + esc(String(prev.product_title).split(/ [—-] /)[0]) + '</b>' : '') + ' por <b>' + fmt(prev.total || 0) + '</b>. Te escribiremos por WhatsApp para confirmarlo.</p>' +
      '<button type="button" class="codf-btn" data-ok>Listo, es ese pedido</button>' +
      '<button type="button" class="codf-link" data-more>Quiero hacer OTRO pedido adicional</button></div>');
    $('[data-ok]', ov).addEventListener('click', function () {
      ov.done(); state.done = true; clearTimeout(leadT);
      thankYou(c, { order_name: prev.order_name, total: prev.total || 0 });
    });
    $('[data-more]', ov).addEventListener('click', function () { ev('duplicate_yes'); ov.done(); send(c, true); });
  }

  // Envío al intermediario como "texto simple": así el navegador no hace la consulta previa de permiso
  // (algunos navegadores dentro de TikTok/Facebook la bloquean) y es más rápido en celulares lentos.
  function postJSON(path, data, retries) {
    var url = D.endpoint.replace(/\/$/, '') + path, body = JSON.stringify(data);
    return new Promise(function (resolve, reject) {
      (function attempt(left, wait) {
        fetch(url, { method: 'POST', headers: { 'Content-Type': 'text/plain;charset=UTF-8' }, body: body })
          .then(function (r) { return r.json().catch(function () { return { ok: false, error: 'Respuesta inválida del servidor (' + r.status + ')' }; }); })
          .then(resolve)
          .catch(function (e) { if (left > 0) setTimeout(function () { attempt(left - 1, wait * 2); }, wait); else reject(e); });
      })(retries || 0, 1200);
    });
  }

  function setSending(on) {
    state.sending = on;
    var b = $('.codf-btn', form);
    b.disabled = on; b.classList.toggle('is-loading', on);
    if (on) $('.codf-btn-t', root).textContent = 'Enviando tu pedido…'; else refreshSummary();
  }

  function send(c, repeat) {
    var err = $('.codf-error', root); err.textContent = '';
    setSending(true);
    var payload = {
      product_id: P.id, variant_id: state.variant.id, units: unitIds(), offer_index: OFFERS ? state.offer : -1,
      downsell: state.downsell, bump: (state.bump && BUMP) ? 1 : undefined, upsell_accepted: state.upsell, upsell_variant_id: UP ? UP.variant_id : null,
      customer: c, tracking: tracking(), session: SID, sec: secInfo(), nopx: NO_PX || undefined, ab: AB, ver: window.__codfVer || undefined, lead: state.lead, confirm_repeat: !!repeat,
      test: /[?&]codf_test=1/.test(location.search),
      dry_run: /[?&]codf_dry=1/.test(location.search),
    };
    postJSON('/order', payload, 2)
      .then(function (res) {
        if (res.duplicate) { setSending(false); showDuplicate(c, res.prev); return; }
        if (!res.ok) {
          setSending(false);
          if (res.fields) showErrors(res.fields);
          err.textContent = res.error || 'No pudimos enviar tu pedido. Intenta de nuevo.';
          ev('error', 'servidor:' + (res.error || '').slice(0, 120));
          return;
        }
        if (!res.order_name || !res.order_id) { setSending(false); err.textContent = 'No pudimos confirmar tu pedido. Toca de nuevo "Confirmar pedido".'; ev('error', 'respuesta_sin_pedido'); return; }
        res.items = res.items || [];
        state.done = true; state.sending = false; clearTimeout(leadT);
        if (res.repeat) { thankYou(c, res); return; } // doble clic: el pedido ya existía, no repetir la compra en los píxeles
        identify(c);
        try { sessionStorage.removeItem('codf_lead_' + P.id); } catch (e) {}
        track('Purchase', {
          value: res.total, currency: res.currency, content_type: 'product',
          content_ids: res.items.map(function (i) { return String(i.product_id || i.id); }),
          num_items: res.items.reduce(function (a, i) { return a + i.quantity; }, 0),
        }, res.event_id);
        thankYou(c, res);
      })
      .catch(function (e) {
        setSending(false);
        err.textContent = 'No se pudo enviar. Revisa tu internet y toca de nuevo "Confirmar pedido".';
        ev('error', 'conexion:' + String(e && e.message || e).slice(0, 60) + ' online:' + (navigator.onLine !== false) + ' ua:' + navigator.userAgent.replace(/.*\) /, '').slice(0, 60));
      });
  }

  function unitIds() { return unitsList(unitsCount()).map(function (v) { return v.id; }); }
  function unitsText() {
    var us = unitsList(unitsCount()), count = {};
    if (!OPTS.length) return '';
    us.forEach(function (v) { count[v.title] = (count[v.title] || 0) + 1; });
    return Object.keys(count).map(function (k) { return (us.length > 1 ? count[k] + ' ' : '') + k; }).join(' + ');
  }

  // ------------------------------------------------------------ gracias + WhatsApp
  function thankYou(c, res) {
    var wa = S.whatsapp || {};
    var products = P.title + (OPTS.length ? ' (' + unitsText() + ')' : '') + ' x' + calc().qty + (state.upsell ? ' + ' + UP.title : '');
    var msg = (wa.message || 'Hola 👋 mi nombre es {nombre}. Hice el pedido {pedido} de {productos} por {total} y quiero confirmarlo.')
      .replace(/\{nombre\}|\{\{customer\.name\}\}/g, (c.first_name + ' ' + c.last_name).trim())
      .replace(/\{pedido\}|\{\{order\.number\}\}/g, res.order_name)
      .replace(/\{productos\}|\{\{order\.products\}\}/g, products)
      .replace(/\{total\}|\{\{order\.total\}\}/g, fmt(res.total));
    // enlace directo (wa.me redirige y en ese salto daña los emojis)
    var waUrl = wa.phone ? 'https://api.whatsapp.com/send?phone=' + String(wa.phone).replace(/\D/g, '') + '&text=' + encodeURIComponent(msg) : '';
    body().innerHTML =
      '<div class="codf-thanks">' +
        '<div class="codf-check" aria-hidden="true">✓</div>' +
        '<h2>¡Gracias, ' + esc(c.first_name) + '!</h2>' +
        '<p>Tu pedido <strong>' + esc(res.order_name) + '</strong> quedó registrado.</p>' +
        '<div class="codf-summary"><div><span>' + esc(products) + '</span></div><div class="codf-total"><span>Pagas al recibir</span><span>' + fmt(res.total) + '</span></div></div>' +
        (GIFT && GIFT.url ? '<a class="codf-gift-dl" href="' + esc(GIFT.url) + '" target="_blank" rel="noopener">🎁 Descarga tu regalo: ' + esc(GIFT.titulo) + '</a>' : '') +
        (waUrl ? '<p class="codf-thanks-note">Confirma tu pedido por WhatsApp para despacharlo más rápido 👇</p><a class="codf-btn codf-wa" href="' + esc(waUrl) + '">Confirmar por WhatsApp</a>' : '<p class="codf-thanks-note">Te contactaremos para confirmar el envío.</p>') +
      '</div>';
    sheet.classList.remove('has-over'); sheet.scrollTop = 0;
    if (waUrl && wa.auto_redirect !== false) setTimeout(function () { location.href = waUrl; }, (wa.redirect_delay_ms || 2500) + (GIFT && GIFT.url ? 4500 : 0));
  }

  // ------------------------------------------------------------ arranque
  // lo pesado va después de que el cliente ya ve la página
  function afterLoad(fn, extra) {
    var go = function () { setTimeout(function () { (window.requestIdleCallback || function (f) { setTimeout(f, 1) })(fn); }, extra || 0); };
    if (document.readyState === 'complete') go(); else window.addEventListener('load', go, { once: true });
  }
  afterLoad(function () { loadPixels(); pageEvents(); }, 300);
  afterLoad(function () { ensureCities(); ensureAddr(); }, 1500);
  ['touchstart', 'scroll', 'mousemove'].forEach(function (t) { window.addEventListener(t, function once() { window.removeEventListener(t, once); setTimeout(function () { ensureCities(); ensureAddr(); }, 400); }, { passive: true }); });
  window.CODF = { open: open, close: close, state: state };
  if ((window.CODF_QUEUE || []).length) open();
  // ---- Páginas de producto "normales" del tema (sin landing propia): ponemos nuestro botón + barra fija
  //      (antes el botón lo ponía EasySell; sin él la página quedaría sin forma de comprar)
  function mountThemeButtons() {
    if (document.querySelector('.codf-cta')) return;
    if (document.querySelector('[onclick*="cod"], [onclick*="COD"], [onclick*="Tyslo"], [data-buy-cta], [data-codf-open]')) return; // la landing ya tiene sus botones
    var forms = [].slice.call(document.querySelectorAll('form[action*="/cart/add"]')).filter(function (f) { return !f.closest('.codf') && !f.closest('[id^="es-"]'); });
    if (!forms.length) return;
    var vis = function (e) { var b = e.getBoundingClientRect(); return b.width > 0 && b.height > 0; };
    var form0 = forms.filter(vis)[0] || forms[0];
    var st = document.createElement('style');
    st.textContent = 'form[action*="/cart/add"] button[name="add"], form[action*="/cart/add"] [type="submit"], .shopify-payment-button, .product-form__buttons > *:not(.codf-cta) { display: none !important; }';
    document.head.appendChild(st);
    var price = (function () { var c = calc(); return fmt(OFFERS ? (state.variant.price / 100) : c.total); })();
    var cta = el('<button type="button" class="codf-cta" data-codf-open><span>' + esc(S.texts && S.texts.cta || 'COMPRAR AHORA') + ' →</span><small>💵 Pagas al recibir · 🚚 Envío gratis</small></button>');
    form0.parentNode.insertBefore(cta, form0.nextSibling);
    var bar = el('<div class="codf-sticky" hidden><div><b>' + esc(price) + '</b><small>Pagas al recibir</small></div><button type="button" data-codf-open>' + esc(S.texts && S.texts.cta || 'COMPRAR AHORA') + '</button></div>');
    document.body.appendChild(bar);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { bar.hidden = en[0].isIntersecting || (root && !root.hidden); }).observe(cta);
    } else { bar.hidden = false; }
  }

  // ---- Eventos de página para los píxeles (los mandaba EasySell; se activan con pixels.page_events)
  function pageEvents() {
    if (!PX.page_events || NO_PX || pageSent) return;
    pageSent = true; loadPixels();
    var data = { content_ids: [String(P.id)], content_type: 'product', content_name: P.title, value: state.variant.price / 100, currency: D.currency };
    // window.__codfPV: el esqueleto liviano de las landings de banners (layout/landing.liquid) ya mandó la visita al abrir
    try { if (window.fbq && (PX.meta || []).length) { if (!window.__codfPV) window.fbq('track', 'PageView'); window.fbq('track', 'ViewContent', data); } } catch (e) {}
    try {
      if (window.ttq && (PX.tiktok || []).length) {
        if (!window.__codfPV) window.ttq.page();
        window.ttq.track('ViewContent', { value: data.value, currency: data.currency, content_type: 'product', contents: [{ content_id: String(P.id), content_name: P.title, quantity: 1, price: data.value }] });
      }
    } catch (e) {}
  }

  // ---- La imagen principal (hero) también abre el formulario: mucha gente toca la foto esperando que pase algo.
  // Solo la primera imagen grande de arriba (no galerías con zoom, ni enlaces, ni el encabezado).
  function markHero() {
    if (document.querySelector('[data-codf-hero]')) return;
    var W = window.innerWidth, H = window.innerHeight;
    var imgs = [].slice.call(document.querySelectorAll('main img, main picture, #MainContent img')).filter(function (im) {
      if (im.closest('header, footer, .codf, .codf-sticky, a, button, [role=dialog], media-gallery, slider-component, .product__media-list, .product-media-modal, .shopify-section-header')) return false;
      var b = im.getBoundingClientRect();
      return b.width >= W * 0.7 && b.height >= 120 && b.top + window.scrollY < H * 1.2;
    }).sort(function (a, b) { return a.getBoundingClientRect().top - b.getBoundingClientRect().top; });
    var hero = imgs[0];
    if (!hero) return;
    hero.setAttribute('data-codf-hero', '');
    hero.style.cursor = 'pointer';
  }
  if (S.hero_tap !== false) afterLoad(markHero, 300);   // 2026-10-06: apagado (hero_tap:false) — 159 aperturas por la foto, 0 pedidos

  // ¿de dónde viene el toque? (se mira ANTES de que el botón de la landing abra el formulario)
  document.addEventListener('click', function (e) {
    var t = e.target, src = 'boton';
    for (var n = t, i = 0; n && n !== document.body && i < 8; n = n.parentElement, i++) {
      if (n.classList && n.classList.contains('codf')) return;
      if (getComputedStyle(n).position === 'fixed') { src = 'fijo'; break; }
    }
    if (t.closest && t.closest('[data-codf-hero]')) src = 'hero';
    state.openSrc = src;
    setTimeout(function () { state.openSrc = null; }, 600);   // si el toque no abrió el formulario, se olvida
  }, true);

  // Clic en cualquier botón marcado como CTA
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[data-codf-hero]') && !(root && !root.hidden)) { e.preventDefault(); open(); return; }
    var b = e.target.closest('[data-buy-cta], [data-codf-open], a[href="#comprar"], a[href="#pedido"]');
    if (b) { e.preventDefault(); open(); }
  });
  if (/[?&]codf_open=1/.test(location.search)) open();
  // prueba A/B de oferta (cp-lb pone window.__codfVer = 'oferta-a' / 'oferta-b'): queda en la visita para medir cuál deja más (prueba_oferta.py)
  ev('view', [STK(), window.__codfVer || ''].filter(Boolean).join('|'));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mountThemeButtons); else mountThemeButtons();

  // Enlace de recuperación (?codf_r=...): abre el formulario ya lleno con lo que el cliente había escrito
  var rec = new URLSearchParams(location.search).get('codf_r');
  if (rec && D.endpoint) {
    fetch(D.endpoint.replace(/\/$/, '') + '/recover?t=' + encodeURIComponent(rec))
      .then(function (r) { return r.json(); })
      .then(function (r) {
        if (!r || !r.ok) return;
        state.lead = r.lead;
        var v = r.variant_id && P.variants.find(function (x) { return (String(x.id) === String(r.variant_id) || (r.variant_title && x.title === r.variant_title)) && x.available; });
        if (v) { state.variant = v; state.units = null; }
        try { localStorage.setItem(MEM_KEY, JSON.stringify(r.customer)); } catch (e) {}
        if (!root) build(); else renderForm();
        fillForm(r.customer);
        ev('recover_open');
        open();
      }).catch(function () {});
  }
})();
